//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { Enums } from "../../../models/common"
import { OpTask } from "../../../models/core"
import { IOpObject } from "../../../models/util/interfaces"

import { EventsNames, LocalizationHelper, CommonHelper, TypeHelper, ConvertHelper, ToastHelper } from "../../../helpers"
import { PopupType } from "../../../helpers/popup-manager"
import { TaskService } from '../../../services/task'
import { UserSessionService } from '../../../services/user-session'

import { CreateEditController, CreateEditScope } from "../../common/common.create-edit.controller"
import { LoggerService } from "../../common/common.module"
import { CreateEditInitParams, BulkEditInitParams } from "../../common/create-edit-popup/create-edit-popup.controller"

interface TaskCreateEditScope extends CreateEditScope { }

export class TaskCreateEditController extends CreateEditController {

    // #region Members

    private referenceValue: OpTask

    // #endregion


    // #region Ctor

    constructor(
        private $scope: TaskCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        protected userSessionService: UserSessionService,
        private taskService: TaskService,
        private referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // #endregion


    // #region Events

    private onInit(args: any[]): void {
        const param: any = _.first(args)
        if (param != null) {
            const createEditInitParams: CreateEditInitParams = param

            this.referenceValue = createEditInitParams ? <OpTask>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.referenceValue != null && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onInitBulk(args: any[]): void {
        if (args != null && args[0] != null) {
            const bulkEditInitParams: BulkEditInitParams = args[0]
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)
            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)
            this.$scope.gridData = args[0]
            if (args.length > 1 && args[1] != null) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()
        const task: OpTask = OpTask.fromIOpObject(objectToSave)

        if (this.referenceValue == null) {
            task.creationDate = new Date()
        } else {
            task.creationDate = this.referenceValue.creationDate
        }

        this.taskService
            .saveTask(task)
            .then((savedObject: OpTask) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail(() => {
                deferred.reject()
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()
        const task: OpTask = OpTask.fromIOpObject(objectToSave)

        task.opState = Enums.OpChangeState.Modified

        this.taskService
            .saveTask(task, true)
            .then((savedObject: OpTask) => {
                deferred.resolve(savedObject)
            }).fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(errorMsg)
            })

        return deferred.promise
    }

    // #endregion


    // #region Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => { this.onInit(args) }
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => { this.onInitBulk(args) }
        )
    }

    private setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.taskSaved,
            onSubmit: null,
            onClose: null,
            referenceType: this.referenceType,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: TypeHelper.emptyString,
            type: null,

            onBulkSave: (objectToSave: IOpObject) => { return this.onBulkSave(objectToSave) },
            onSave: (objectToSave: IOpObject) => { return this.onSave(objectToSave) },
        }
    }

    // #endregion
}